const requireComponent = require.context(
  './request', // 在当前目录下查找
  true, // 不遍历子文件夹
  /\.js$/ // 正则匹配 以 .js结尾的文件
)
let api = {}
requireComponent.keys().forEach(key => {
  // 合并对象
  const item = requireComponent(key)
  api = Object.assign(api, item)
})
export default api
